/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AIModelPrice } from '../model';
// @ts-ignore
import type { AIUsageEventPage } from '../model';
// @ts-ignore
import type { AIUsageEventSorting } from '../model';
// @ts-ignore
import type { AIUsageOrganizationOverview } from '../model';
// @ts-ignore
import type { AIUsageOverview } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
/**
 * AiUsageApi - axios parameter creator
 */
export const AiUsageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Ai Usage Overview
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {boolean} [includeInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiUsageOverview: async (startDate?: string | null, endDate?: string | null, includeInternal?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai-usage/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (includeInternal !== undefined) {
                localVarQueryParameter['include_internal'] = includeInternal;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Ai Usage Overview
         * @param {string} organizationId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAiUsageOverview: async (organizationId: string, startDate?: string | null, endDate?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationAiUsageOverview', 'organizationId', organizationId)
            const localVarPath = `/ai-usage/organizations/{organization_id}/overview`
                .replace('{organization_id}', encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Ai Model Prices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiModelPrices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai-usage/prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Ai Usage Events
         * @param {AIUsageEventSorting} [sortBy] 
         * @param {boolean} [descending] 
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {boolean} [includeInternal] 
         * @param {string | null} [organizationId] 
         * @param {string | null} [feature] 
         * @param {string | null} [operation] 
         * @param {string | null} [userId] 
         * @param {string | null} [projectId] 
         * @param {string | null} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiUsageEvents: async (sortBy?: AIUsageEventSorting, descending?: boolean, page?: number, size?: number, startDate?: string | null, endDate?: string | null, includeInternal?: boolean, organizationId?: string | null, feature?: string | null, operation?: string | null, userId?: string | null, projectId?: string | null, model?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ai-usage/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (includeInternal !== undefined) {
                localVarQueryParameter['include_internal'] = includeInternal;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (feature !== undefined) {
                localVarQueryParameter['feature'] = feature;
            }

            if (operation !== undefined) {
                localVarQueryParameter['operation'] = operation;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiUsageApi - functional programming interface
 */
export const AiUsageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiUsageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Ai Usage Overview
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {boolean} [includeInternal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAiUsageOverview(startDate?: string | null, endDate?: string | null, includeInternal?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIUsageOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAiUsageOverview(startDate, endDate, includeInternal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiUsageApi.getAiUsageOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Organization Ai Usage Overview
         * @param {string} organizationId 
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationAiUsageOverview(organizationId: string, startDate?: string | null, endDate?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIUsageOrganizationOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationAiUsageOverview(organizationId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiUsageApi.getOrganizationAiUsageOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Ai Model Prices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAiModelPrices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AIModelPrice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAiModelPrices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiUsageApi.listAiModelPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Ai Usage Events
         * @param {AIUsageEventSorting} [sortBy] 
         * @param {boolean} [descending] 
         * @param {number} [page] Page number
         * @param {number} [size] Page size
         * @param {string | null} [startDate] 
         * @param {string | null} [endDate] 
         * @param {boolean} [includeInternal] 
         * @param {string | null} [organizationId] 
         * @param {string | null} [feature] 
         * @param {string | null} [operation] 
         * @param {string | null} [userId] 
         * @param {string | null} [projectId] 
         * @param {string | null} [model] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAiUsageEvents(sortBy?: AIUsageEventSorting, descending?: boolean, page?: number, size?: number, startDate?: string | null, endDate?: string | null, includeInternal?: boolean, organizationId?: string | null, feature?: string | null, operation?: string | null, userId?: string | null, projectId?: string | null, model?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIUsageEventPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAiUsageEvents(sortBy, descending, page, size, startDate, endDate, includeInternal, organizationId, feature, operation, userId, projectId, model, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AiUsageApi.listAiUsageEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AiUsageApi - factory interface
 */
export const AiUsageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiUsageApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Ai Usage Overview
         * @param {AiUsageApiGetAiUsageOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAiUsageOverview(requestParameters: AiUsageApiGetAiUsageOverviewRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AIUsageOverview> {
            return localVarFp.getAiUsageOverview(requestParameters.startDate, requestParameters.endDate, requestParameters.includeInternal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Ai Usage Overview
         * @param {AiUsageApiGetOrganizationAiUsageOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAiUsageOverview(requestParameters: AiUsageApiGetOrganizationAiUsageOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIUsageOrganizationOverview> {
            return localVarFp.getOrganizationAiUsageOverview(requestParameters.organizationId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Ai Model Prices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiModelPrices(options?: RawAxiosRequestConfig): AxiosPromise<Array<AIModelPrice>> {
            return localVarFp.listAiModelPrices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Ai Usage Events
         * @param {AiUsageApiListAiUsageEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiUsageEvents(requestParameters: AiUsageApiListAiUsageEventsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AIUsageEventPage> {
            return localVarFp.listAiUsageEvents(requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, requestParameters.startDate, requestParameters.endDate, requestParameters.includeInternal, requestParameters.organizationId, requestParameters.feature, requestParameters.operation, requestParameters.userId, requestParameters.projectId, requestParameters.model, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAiUsageOverview operation in AiUsageApi.
 */
export interface AiUsageApiGetAiUsageOverviewRequest {
    readonly startDate?: string | null

    readonly endDate?: string | null

    readonly includeInternal?: boolean
}

/**
 * Request parameters for getOrganizationAiUsageOverview operation in AiUsageApi.
 */
export interface AiUsageApiGetOrganizationAiUsageOverviewRequest {
    readonly organizationId: string

    readonly startDate?: string | null

    readonly endDate?: string | null
}

/**
 * Request parameters for listAiUsageEvents operation in AiUsageApi.
 */
export interface AiUsageApiListAiUsageEventsRequest {
    readonly sortBy?: AIUsageEventSorting

    readonly descending?: boolean

    /**
     * Page number
     */
    readonly page?: number

    /**
     * Page size
     */
    readonly size?: number

    readonly startDate?: string | null

    readonly endDate?: string | null

    readonly includeInternal?: boolean

    readonly organizationId?: string | null

    readonly feature?: string | null

    readonly operation?: string | null

    readonly userId?: string | null

    readonly projectId?: string | null

    readonly model?: string | null
}

/**
 * AiUsageApi - object-oriented interface
 */
export class AiUsageApi extends BaseAPI {
    /**
     * 
     * @summary Get Ai Usage Overview
     * @param {AiUsageApiGetAiUsageOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAiUsageOverview(requestParameters: AiUsageApiGetAiUsageOverviewRequest = {}, options?: RawAxiosRequestConfig) {
        return AiUsageApiFp(this.configuration).getAiUsageOverview(requestParameters.startDate, requestParameters.endDate, requestParameters.includeInternal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Ai Usage Overview
     * @param {AiUsageApiGetOrganizationAiUsageOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOrganizationAiUsageOverview(requestParameters: AiUsageApiGetOrganizationAiUsageOverviewRequest, options?: RawAxiosRequestConfig) {
        return AiUsageApiFp(this.configuration).getOrganizationAiUsageOverview(requestParameters.organizationId, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Ai Model Prices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAiModelPrices(options?: RawAxiosRequestConfig) {
        return AiUsageApiFp(this.configuration).listAiModelPrices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Ai Usage Events
     * @param {AiUsageApiListAiUsageEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAiUsageEvents(requestParameters: AiUsageApiListAiUsageEventsRequest = {}, options?: RawAxiosRequestConfig) {
        return AiUsageApiFp(this.configuration).listAiUsageEvents(requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, requestParameters.startDate, requestParameters.endDate, requestParameters.includeInternal, requestParameters.organizationId, requestParameters.feature, requestParameters.operation, requestParameters.userId, requestParameters.projectId, requestParameters.model, options).then((request) => request(this.axios, this.basePath));
    }
}

